import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["select"];

  change() {
    const value = this.selectTarget.value;
    const maxAge = 60 * 60 * 24 * 7; // 7 days
    document.cookie = `portal_location_id=${value};path=/portal;max-age=${maxAge};SameSite=Lax`;
    Turbo.visit(window.location.href, { action: "replace" });
  }
}
